import {SwapHoriz} from '@mui/icons-material';
import {Box, Divider, Stack, Typography} from '@mui/material';
import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import {INode} from './type';
import {t} from 'i18next';
import './InnerTextFrame.scss';
interface IInnerTextFrame {
  item: INode;
}

const InnerTextFrame = ({item}: IInnerTextFrame) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const textRef = useRef<HTMLDivElement | null>(null);
  const [fontSize, setFontSize] = useState(30);

  useLayoutEffect(() => {
    if (!item?.name) return;
    const container = containerRef.current;
    const text = textRef.current;
    if (!container || !text) return;
    let currentSize = 30;
    text.style.fontSize = `${currentSize}px`;
    while (text.offsetWidth + 30 > container.offsetWidth && currentSize > 8) {
      currentSize--;
      text.style.fontSize = `${currentSize}px`;
    }
    setFontSize(currentSize);
  }, [item.name]);
  let typoClass: string;
  if (item.radius >= 50) typoClass = 'display3_size';
  else if (item.radius > 40) typoClass = 'subhead5_size';
  else typoClass = 'subhead5_size';

  // Determine SwapHoriz icon size based on radius
  let iconSize: 'small' | 'medium' | 'large';
  if (item.radius >= 50) iconSize = 'large';
  else if (item.radius > 40) iconSize = 'small';
  else iconSize = 'small';

  return (
    <>
      {item.name === 'OTHERS' ? (
        <Box className="others-box">
          <Typography
            className={`typo-text subhead3_size text-inverse-heading`}
            data-testid={`inner-text-frame-title`}>
            {t('reports.communicationExplorer.others.title')}
          </Typography>
          <Typography
            className={`typo-text body2_size text-inverse-body`}
            data-testid={`${item.id}-exchange-count`}
          >
            {t('reports.communicationExplorer.others.body', {
              exchangeCount: item.exchangeCount,
            })}
          </Typography>
        </Box>
      ) : (
        <>
          {item.name.length / item.radius < 0.2 && ( //check text and radius ratio if text is fitting inside
            (<Stack className="inner-text-frame-stack" ref={containerRef}>
              <Typography
                className="typo-text"
                data-testid={`${item.id}-name`}
                sx={{
                  fontSize: `${fontSize}px`,
                }}
                ref={textRef}
              >
                {item.name}
              </Typography>
              <Divider className="divider" />
            </Stack>)
          )}

          <Stack
            direction={'row'}
            className="stack-container"
            justifyContent="center"
          >
            <Typography
              className={`typo-text ${typoClass}`}
              sx={{userSelect: 'none'}}
              data-testid={`${item.id}-exchange-count`}
            >
              {item.exchangeCount}
            </Typography>
            <SwapHoriz fontSize={iconSize} />{' '}
          </Stack>
        </>
      )}
    </>
  );
};

export default InnerTextFrame;
